import * as React from "react";
import { connect } from "react-redux";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { queryParams } from "../../helpers/formatting";
import Spinner from "../common/spinner";
import { Redirect } from 'react-router-dom';


class ScheduleVisitRedirect extends React.Component {
    constructor(props) {
        super(props);

        this.findcareSearchParms = "?" + queryParams({ keyword: "primary care provider", vector: "pcp", isScheduleAnnualCampaign: true }); //default search params for schedule annual campaign
       
       
    }

    componentDidMount() {
        logUI(`MBHWeb.UI.ScheduleVisitRedirect.ComponentDidMount`, new Date(), Tools.getURLPath());

    }


    render() {

        const { hasMychart,
            providerList,
            providerListFailure,
            providerListPending,
            providerListSuccess,
            myProxies,
            proxyListFailure,
            proxyListLoading,
            proxyListLoaded } = this.props;
        const hasProxies =  myProxies && myProxies.length > 1;
        const hasProviders = providerList && providerList.length > 0;
        let isWaiting = hasMychart &&
            (providerListPending || (!providerListFailure && !providerListSuccess))
            || (proxyListLoading || (!proxyListFailure && !proxyListLoaded));
        let redirecToURL = '/findcare'; //default redirect url
        const thisPath = this.props.history.location?.pathname.slice(1) || 'SCHEDULEANNUALCAMPAIGN';

        if (hasMychart) {          
           
            if (hasProviders) {
                if (hasProxies) {
                    redirecToURL = '/schedulingFor';
                } else {
                    redirecToURL = '/schedulevisit';
                }
            } else {
                redirecToURL = '/findcare';
            }
        }
        else {
            redirecToURL = '/findcare';
        }              


        return(
            <>
                {(isWaiting) ?
                    <>
                        <div className="container-fluid body-content">
                            <Spinner />
                        </div>
                    </>
                    : <Redirect to={{
                        pathname: redirecToURL,
                        search: redirecToURL.includes('/findcare') ? this.findcareSearchParms : undefined,
                        state: { scheduleCampaignReferrer: thisPath }
                    }} />
                }
               
         </>
        );
    }

}
const mapStateToProps = (state) => {
    const pl = [];
    if (state.domain.pl) {
        state.domain.pl.forEach((proxy) => {
            pl.push(d.hydrateProxyUser(proxy));
        });
    }
    return {
        providerList: state.directScheduling.providerList,
        providerListFailure: state.directScheduling.providerListFailure,
        providerListPending: state.directScheduling.providerListPending,
        providerListSuccess: state.directScheduling.providerListSuccess,
        hasMychart: state.domain.hm,
        myProxies: pl,
        proxyListFailure: state.memberships.proxyListFailure,
        proxyListLoaded: state.memberships.proxyListLoaded,
        proxyListLoading: state.memberships.proxyListLoading,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentUser: d.hydrateProxyUser(state.domain.cu),
        userName: state.sso.userDetails.userName,
        isProxyUser: state.domain.ip

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleVisitRedirect);